import * as React from 'react';
import * as styles from './styles.css';

import { ConditionalWrapper } from '@cian/conditional-component';
import { Header0, Header1, InlineText1 } from '@cian/ui-kit/typography';
import { Button } from '@cian/ui-kit/button';
import { useDeviceType } from '@cian/ui-kit/responsive';

import { PolicyAgreement } from '../PolicyAgreement';
import { formContextObj } from '../../containers/FormContainer';

export function Intro() {
  const { startQuiz } = React.useContext(formContextObj);
  const deviceType = useDeviceType();
  const isMobile = deviceType !== 'desktop';

  return (
    <div className={styles['container']}>
      <div>
        {isMobile && <div className={styles['img']} />}
        <div className={styles['title']}>
          <ConditionalWrapper if={isMobile} ThenComponent={Header1} ElseComponent={Header0}>
            <span>
              Бесплатно подберем
              <br />
              надежного риелтора
            </span>
          </ConditionalWrapper>
        </div>
        <ul className={styles['list']}>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <InlineText1>1</InlineText1>
            </span>
            <InlineText1>Заполните короткую анкету. Это займет не более 3 минут</InlineText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <InlineText1>2</InlineText1>
            </span>
            <InlineText1>Мы отправим анкету риелторам, которые сотрудничают с нами</InlineText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <InlineText1>3</InlineText1>
            </span>
            <InlineText1>Вам позвонит не более 3 риелторов. Они уточнят детали и ответят на вопросы</InlineText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <InlineText1>4</InlineText1>
            </span>
            <InlineText1>
              Вы обсудите условия сотрудничества, стоимость услуг и выберите подходящего риелтора
            </InlineText1>
          </li>
        </ul>
        <div className={styles['button-sticky']} data-testid="quizStart">
          <Button theme="fill_primary" size="M" onClick={startQuiz} fullWidth={isMobile}>
            Заполнить анкету
          </Button>
        </div>
      </div>
      {isMobile && (
        <div className={styles['footer']}>
          <PolicyAgreement />
        </div>
      )}
    </div>
  );
}
